import type * as d3 from 'd3';

export type SVGSelection = d3.Selection<SVGSVGElement, unknown, null, undefined>;
export type D3Selection = d3.Selection<d3.BaseType, unknown, null, undefined>;
export type TextSelection = d3.Selection<SVGTextElement, unknown, null, undefined>;
export type CircleSelection = d3.Selection<SVGCircleElement, unknown, null, undefined>;
export type GroupSelection = d3.Selection<SVGGElement, unknown, null, undefined>;
export interface ToolOptions {
  svgElement: SVGSVGElement;
  validTexts: number[];
  defaultCallout: number;
}
export interface Callback {
  (...args: any[]): any;
}

export enum EVENTTYPES {
  TEXTCLICK = 'TextClick'
}

export enum CIRCLETYPES {
  DEFAULT = 'default',
  SELECTED = 'selected',
  HOVER = 'hover',
  DISABLED = 'disabled'
}

type StatusMapItem = {
  flag: string;
  circleStroke: string; // circle边框颜色
  circleRadius: string; // circle半径
  circleFill: string; // circle填充颜色
  textFill?: string; // 文本颜色
};

export const StatusMapEnum = {
  DEFAULT: {
    flag: 'default',
    circleStroke: 'none',
    circleRadius: '14',
    circleFill: 'none',
    textFill: '#003684'
  },
  SELECTED: {
    flag: 'selected',
    circleStroke: 'none',
    circleRadius: '14',
    circleFill: '#0068FF',
    textFill: '#FFFFFF'
  },
  DISABLED: {
    flag: 'disabled',
    circleStroke: 'none',
    circleRadius: '14',
    circleFill: 'none',
    textFill: '#B0B3B8'
  },
  HOVER: {
    flag: 'hover',
    circleStroke: 'rgba(0, 104, 255, 0.35)',
    circleRadius: '15.2',
    circleFill: 'none'
  },
  DISABLED_HOVER: {
    flag: 'hover',
    circleStroke: 'rgba(217, 166, 0, 0.35)',
    circleRadius: '15.2',
    circleFill: 'none'
  }
} as Record<string, StatusMapItem>;
